export const en = {
    // English translations:
    required: '* Required field',
    validation: {
        required: controlName => `Insert ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        minmaxNotLessThen: (controlName, min) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} cannot be smaller than ${min}`,
        minmaxNotGreaterThen: (controlName, max) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} cannot be bigger than ${max}`,
    },
    switch: {
        yes: 'Yes',
        no: 'No',
    },
    dateRange: {
        arrival: 'Arrival',
        departure: 'Departure',
    },
    travelData: {
        title: 'Enter your holiday dates and receive personalised offers directly from the hosts by e-mail!',
        range: 'arrival & departure date',
        hasPets: 'Animals',
        petsMessage: 'pet description',
        petsMessagePlaceholder: "e.g. 1 big dog (about 10 kg), 2 cats…",
        boards: 'Meal type',
        rooms: {
            validation: {
                roomsMissing: 'Insert at least 1 room',
                adultsMissing: 'Insert number of adults',
                roomsWithoutAdults: 'Insert at least 1 adult for each room',
                childAgeMissing: 'Insert age of the children',
            },
            adults: 'Adults',
            children: 'Children',
            rooms: 'Rooms',
            age: 'Age',
            room: 'Room/apartment',
            roomInfo: 'This indication corresponds to a room, an apartment, a camping pitch, etc.',
            removeRoom: 'Remove room/apartment',
            addRoom: 'Add room/apartment',
            childrenAges: 'Age of the children',
            years: age => `${age} ${age == 1 ? 'year' : 'years'}`,
            done: 'Done',
        },
        submit: 'Continue',
    },
    filter: {
        title: 'Select the desired accommodation type and your favourite region and receive accommodation suggestions!',
        accotypesValidatorText: controlName => `Choose ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        areaValidatorText: controlName => `Choose ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        maxCountValidatorText: (controlName, max) => `A maximum of ${max} accommodations may be selected.\nUse other filters.`,
        accotypesAndBoards: 'Accommodation type & meal type',
        boards: 'Meal type',
        accotypes: 'Accommodation type',
        areas: 'Regions & localities',
        resorts: 'Localities',
        regions: 'Regions',
        selectAllRegions: 'Select all regions in South Tyrol',
        searchAreas: 'Search regions & localities…',
        themesAmeneties: 'Amenities / Holiday type',
        ameneties: 'Amenities',
        themes: 'Holiday type',
        overlay: {
            accosText: count => `<b>${count}</b> ${count == 1 ? "accommodation" : "accommodations"} selected`,
            done: 'Done',
        },
        back: 'Back',
        submitContinueWith: 'Continue with',
        submitAccosText: count => `${count} ${count == 1 ? "accommodation" : "accommodations"}`,
    },
    accos: {
        title: 'Accommodation overview',
        subtitle: (selected, count) => `Request ${selected} ${selected == 1 ? "accommodation" : "accommodations"} or select individual ones`,
        back: 'Back',
        submitContinueWith: 'Continue with',
        submitAccosText: count => `${count} ${count == 1 ? "accommodation" : "accommodations"}`,
    },
    personalData: {
        accosCount: count => `<b>${count}</b> ${count == 1 ? "accommodation" : "accommodations"}`,
        adults: count => `<b>${count}</b> ${count == 1 ? 'adult' : 'adults'}`,
        children: count => `<b>${count}</b> ${count == 1 ? 'child' : 'children'}`,
        rooms: count => `<b>${count}</b> ${count == 1 ? 'room' : 'rooms'}`,
        pets: 'pet/s',
        accotypes: count => `${count == 1 ? 'Accommodation type:' : 'Accommodation types:'}`,
        areas: count => `${count == 1 ? 'Region/location:' : 'Regions/localities:'}`,
        
        title: 'Enter contact details to receive personalised offers directly from the hosts!',
        email: 'E-mail',
        salutation: 'Title',
        salutationOptions: {
            herr: 'Mr',
            frau: 'Mrs',
            familie: 'Family',
            firma: 'Company',
        },
        firstname: 'First name',
        lastname: 'Surname',
        phone: 'Phone',
        message: 'Comments & questions',
        privacy: privacyUrl => `Yes, I agree to the <a href="${privacyUrl}" target="_blank">processing of my personal data.</a>`,
        privacyRequired: 'Agree to the data processing',
        newsletter: 'Yes, I would like to receive the newsletter by south-tirol.com.',
        newsletterNote: 'Our free newsletter is regularly sent once a month. It includes the best offers for a holiday in South Tyrol as well as current tips by our editorial office. Unsubscribing is possible at any time.',
        generalError: 'An error has occured. Try again later.',
        back: 'Back',
        submit: count => `Send request now`,
    },
    thankyou: {
        title: 'Request successful',
        successText: 'Your request has been sent successfully',
    },
};
//# sourceMappingURL=Enquiry.i18n.en.js.map